module.exports = __webpack_public_path__ + "img/Standard.0763a05e.jpg";